<script>
export default {
  name: 'SkiSchoolPersonCategory',
  props: {
    category: {
      type: Object,
      required: true,
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      personCategoryItem: Object.assign({}, this.category),
    };
  },
  methods: {
    onPersonCategoryChange(params) {
      this.$emit('onPersonCategoryChange', {
        personCategoryItem: this.personCategoryItem,
        params,
      });
      if (params.ageFrom) {
        this.$nextTick(() => {
          const element = 'ageFrom'.concat(this.personCategoryItem.ageFrom);
          this.$refs[element].focus();
        });
      }
    },
  },
  watch: {
    category: {
      deep: true,
      handler() {
        this.personCategoryItem = Object.assign({}, this.category);
      },
    },
  },
};
</script>

<template>
  <v-container class="pa-0">
    <v-layout wrap>
      <v-flex class="text-xs-right pr-4 pt-3" sm1 xs12>
        <h3 :class="{'red--text': !personCategoryItem.id}">
          {{ personCategoryItem.id ? '#' + personCategoryItem.id : $t('buttons.new') }}
        </h3>
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          @input="onPersonCategoryChange({ nameSupplier: $event })"
          v-model="personCategoryItem.externalName"
          :placeholder="$t('ski.skiPersonCategory.nameSupplier')"
          :disabled="saveLoading"
          solo
        />
      </v-flex>
      <v-flex sm2 xs12>
        <v-text-field
          @input="onPersonCategoryChange({ nameWeb: $event })"
          v-model="personCategoryItem.name"
          :placeholder="$t('ski.skiPersonCategory.nameWebsite')"
          :disabled="saveLoading"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          @input="onPersonCategoryChange({ ageFrom: $event })"
          v-model="personCategoryItem.ageFrom"
          :placeholder="$t('ski.skiPersonCategory.ageFrom')"
          :disabled="saveLoading"
          :ref="'ageFrom' + personCategoryItem.ageFrom"
          type="Number"
          max="99"
          min="0"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12>
        <v-text-field
          @input="onPersonCategoryChange({ ageTo: $event })"
          v-model="personCategoryItem.ageTo"
          :placeholder="$t('ski.skiPersonCategory.ageTo')"
          :disabled="saveLoading"
          type="Number"
          max="99"
          min="0"
          solo
        />
      </v-flex>
      <v-flex sm1 xs12 class="pl-2 pt-0">
        <v-btn
          @click="$emit('createOrUpdate', category)"
          :disabled="saveLoading"
          class="mb-2"
          color="green"
          small
          outline
        >
          {{ category.id ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      </v-flex>
      <v-flex sm1 xs12 class="pl-4 pt-0">
        <v-btn
          @click="$emit('remove', category.id)"
          :disabled="saveLoading"
          :color="category.id ? 'error' : 'warning'"
          class="mb-2"
          small
          outline
        >
          {{ category.id ? $t('buttons.remove') : $t('buttons.cancel') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/ski/school/SkiSchoolPersonCategory.vue